// extracted by mini-css-extract-plugin
export var actions = "BottomHero-module--actions--spNjd";
export var btn = "BottomHero-module--btn--w1yVd";
export var img = "BottomHero-module--img--jI64p";
export var inner = "BottomHero-module--inner--jlMxk";
export var root = "BottomHero-module--root--0PaHZ";
export var title = "BottomHero-module--title--H7u7H";
export var txt = "BottomHero-module--txt--zbonN";